module.exports = __webpack_public_path__ + "static/media/AT.343acd21.svg";